import {
  makeMapStateToProps,
  mapDispatchToProps,
  type StateProps,
  type DispatchProps,
  type ContainerProps,
} from "./map-to-props-factory";
import { createUniversalConnector } from "../universal-connector-factory";
import { withSportsbookBetslipContext, type SportsbookBetslipContext } from "../../context/sportsbook";
import type { ComponentProps } from "./props";

export default withSportsbookBetslipContext(
  ({ localization, config, slots, capabilities, preferences }: SportsbookBetslipContext) => ({
    localization,
    config,
    slots,
    capabilities,
    preferences,
    receiptTopContentPlacement: capabilities.receiptTopContentPlacement,
    upsellReceiptSuggestions: capabilities.upsellReceiptSuggestions,
  }),
)(
  createUniversalConnector<StateProps, DispatchProps, ContainerProps, ComponentProps>(
    makeMapStateToProps,
    mapDispatchToProps,
  ),
);
